<template>
  <!--Amazon-->
  <el-dialog :close-on-click-modal="false"  
    title="Amazon平台类目"
    :visible.sync="visible"
    width="50%"
    center
    class="amazon_category_dialog"
    
  >
    <el-row class="platRow">
      <div class="platType_1" v-for="(item, index) in platTypeList">
        <el-input
          placeholder="请输入内容"
          suffix-icon="el-icon-search"
          v-model.trim="item.inputValue"
          style="width: 185px"
          size="mini"
          @input="searchPlatTypeList(item.pPlatId, item.inputValue, index)"
        >
        </el-input>
        <div class="platType_2">
          <el-row
            class="rowbg"
            @click.native="platTypeTest(item, item_2, index)"
            v-bind:class="{ bg: item_2.platId == item.bgHide }"
            v-for="(item_2, index_2) in item.data"
          >
            <el-col :span="20">{{ item_2.platName }}</el-col>
            <el-col :span="4" class="ch" v-show="item_2.childrenTree.length > 0"
              ><i class="el-icon-arrow-right"></i
            ></el-col>
          </el-row>
        </div>
      </div>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="shopeeDialogVisible = false" size="small"
        >取 消</el-button
      >
      <el-button type="primary" @click="shopeeDialogSubmit" size="small"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { getProductTypeList } from "@/api/plat/platType"

export default {
  data() {
    return {
      platTypeList: [],
    }
  },

  mounted() {
    this.getPlatTypeList("04", 0, "", 0)
  },
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    getPlatTypeList(type, id, platName, index) {
      var params = {
        platNo: type,
        pPlatId: id,
        platName: platName,
      }
      getProductTypeList(params)
        .then((res) => {
          //如果有值,则只替换data
          
          if (platName != "" && platName != null) {
            if (res.rows != null && res.rows != undefined) {
              this.$set(this.platTypeList[index], "data", res.data.rows)
            } else {
              this.$set(this.platTypeList[index], "data", [])
            }
          } else {
            //没有值则替换整个
            for (var i = 0; i < this.platTypeList.length; i++) {
              if (i >= index) {
                this.platTypeList.splice(i, 1)
              }
            }
            if (res.rows != null && res.rows != undefined) {
              this.$set(this.platTypeList, index, res.rows)
            }
          }
          //赋值类目ID
          // this.copyPlatTypeValue = this.getPlatTypeIds()
        })
        .catch((err) => {})
    },
    //搜索别的平台值
    searchPlatTypeList(pId, value, index) {
      this.getPlatTypeList("04", pId, value, index)
    },
    //遍历类目集合,取出ID
    getPlatTypeIds() {
      var platIds = []
      let platTypeList = this.platTypeList
      for (var i = 0; i < this.platTypeList.length; i++) {
        let bgHide2 = this.platTypeList[i].bgHide
        if (bgHide2 == null || bgHide2 == "") {
          break
        }
        platIds.push(this.platTypeList[i].bgHide)
      }
      return platIds
    },
    //如果类目有值则回显
    getPlatProList() {
      var list = this.firstForm.platTypeVale.split(",")
      var platTypeVale = list[list.length - 1]
      if (platTypeVale != null && platTypeVale != "") {
        var params = {
          catId: platTypeVale,
        }
        getList(params)
          .then((res) => {
            for (var i = 0; i < res.data.length; i++) {
              var dataType = res.data[i].dataType
              switch (dataType) {
                case "03":
                  res.data[i].selectValue = []
                  break
                case "06":
                  res.data[i].selectValue = []
                  break
                default:
                  res.data[i].selectValue = ""
              }
            }
            this.platProList = res.data
          })
          .catch((err) => {})
      }
    },
    shopeeDialogSubmit() {},
  },
}
</script>

<style></style>
